/*
 * @Author: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @Date: 2025-04-23 12:01:29
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-12-29 16:04:52
 */
import { useCallback, useRef, useEffect } from 'react'
import { useKeyPress } from './useKeyPress'
import { message } from 'antd'

export function usePhotoNavigation({
  state,
  setState,
  wmTimer,
  handleReportSA,
  handleFetchWatermark,
  handleFetchFolderInfo,
  props
}) {
  const stateRef = useRef(state)
  const photosRef = useRef(props.photos)

  useEffect(() => {
    stateRef.current = state
  }, [state])

  useEffect(() => {
    photosRef.current = props.photos
  }, [props.photos])

  // 查看上一张照片
  const handlePrev = useCallback(() => {
    const { activeIndex } = stateRef.current
    if (activeIndex > 0) {
      if (wmTimer.current) {
        clearTimeout(wmTimer.current)
      }
      const prevPhotoFrame = document.getElementsByClassName('photo-frame')[
        activeIndex - 1
      ]
      if (prevPhotoFrame) {
        prevPhotoFrame.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center'
        })
      }
      setState((prevState) => ({
        ...prevState,
        activeIndex: activeIndex - 1,
        scale: 100,
        rotate: 0,
        watermarkLoading: true,
        showHdButton: false
      }))
      wmTimer.current = setTimeout(() => {
        handleFetchWatermark(activeIndex - 1)
        handleFetchFolderInfo(activeIndex - 1)
      }, 1000)

      // 获取切换后的照片信息用于埋点
      const newActiveIndex = activeIndex - 1
      const currentPhotos = photosRef.current
      if (currentPhotos && currentPhotos.length > 0) {
        const prevPhoto = currentPhotos[newActiveIndex]
        if (prevPhoto) {
          handleReportSA(
            'previous',
            '',
            '',
            '',
            '',
            prevPhoto.largeURL,
            prevPhoto.createdAt
          )
        } else {
          handleReportSA('previous')
        }
      }
    }
  }, [
    setState,
    wmTimer,
    handleReportSA,
    handleFetchWatermark,
    handleFetchFolderInfo
  ])

  // 查看下一张照片
  const handleNext = useCallback(() => {
    const { activeIndex } = stateRef.current
    const currentPhotos = photosRef.current
    if (currentPhotos && activeIndex < currentPhotos.length - 1) {
      if (wmTimer.current) {
        clearTimeout(wmTimer.current)
      }
      const nextPhotoFrame = document.getElementsByClassName('photo-frame')[
        activeIndex + 1
      ]
      if (nextPhotoFrame) {
        nextPhotoFrame.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center'
        })
      }
      setState((prevState) => ({
        ...prevState,
        activeIndex: activeIndex + 1,
        scale: 100,
        rotate: 0,
        watermarkLoading: true,
        showHdButton: false
      }))
      wmTimer.current = setTimeout(() => {
        handleFetchWatermark(activeIndex + 1)
        handleFetchFolderInfo(activeIndex + 1)
      }, 1000)

      // 获取切换后的照片信息用于埋点
      const newActiveIndex = activeIndex + 1
      if (currentPhotos && currentPhotos.length > 0) {
        const nextPhoto = currentPhotos[newActiveIndex]
        if (nextPhoto) {
          handleReportSA(
            'next',
            '',
            '',
            '',
            '',
            nextPhoto.largeURL,
            nextPhoto.createdAt
          )
        } else {
          handleReportSA('next')
        }
      }
    }
  }, [
    setState,
    wmTimer,
    handleReportSA,
    handleFetchWatermark,
    handleFetchFolderInfo
  ])

  const handleClose = useCallback(() => {
    setState((prevState) => ({
      ...prevState,
      visible: false
    }))
  }, [setState])

  // 使用 useKeyPress 处理键盘事件
  useKeyPress(
    37,
    (e) => {
      if (stateRef.current.visible) {
        // 如果上一张照片的isLimitViewByPhotoCount是true，则不进行切换
        const prevPhoto = props.photos[stateRef.current.activeIndex - 1]
        if (prevPhoto?.isLimitViewByPhotoCount) {
          message.warning('团队存储已满，超限照片无法查看')
          return
        }
        handlePrev()
        const galleryElement = document.getElementsByClassName(
          'gallery'
        )[0] as HTMLElement
        if (galleryElement) {
          galleryElement.scrollBy(-109, 0)
        }
      }
    },
    [handlePrev]
  )

  useKeyPress(
    39,
    (e) => {
      if (stateRef.current.visible) {
        // 如果下一张照片的isLimitViewByPhotoCount是true，则不进行切换
        const nextPhoto = props.photos[stateRef.current.activeIndex + 1]
        if (nextPhoto?.isLimitViewByPhotoCount) {
          message.warning('团队存储已满，超限照片无法查看')
          return
        }
        handleNext()
        const galleryElement = document.getElementsByClassName(
          'gallery'
        )[0] as HTMLElement
        if (galleryElement) {
          galleryElement.scrollBy(109, 0)
        }
      }
    },
    [handleNext]
  )

  useKeyPress(
    27,
    (e) => {
      if (stateRef.current.visible) {
        handleClose()
      }
    },
    [handleClose]
  )

  return {
    handlePrev,
    handleNext,
    handleClose
  }
}
